/* ============================================================
   Header JS (header.liquid) – mobile menu + desktop dropdowns
   ============================================================ */
(function () {
  'use strict';

  /* Mobile menu toggle */
  const menuBtn   = qs('.js-menu-toggle');
  const mobileNav = qs('#mobile-nav');
  if (menuBtn && mobileNav) {
    const backdrop = document.createElement('div');
    backdrop.className = 'mobile-nav-backdrop';
    document.body.appendChild(backdrop);

    function openMenu() {
      mobileNav.hidden = false;
      backdrop.classList.add('is-visible');
      menuBtn.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }
    function closeMenu() {
      mobileNav.hidden = true;
      backdrop.classList.remove('is-visible');
      menuBtn.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    menuBtn.addEventListener('click', () => {
      mobileNav.hidden ? openMenu() : closeMenu();
    });

    backdrop.addEventListener('click', closeMenu);

    qsa('.mobile-nav__toggle').forEach(btn => {
      btn.addEventListener('click', () => {
        const sub  = btn.nextElementSibling;
        const open = sub.hidden;
        sub.hidden = !open;
        btn.setAttribute('aria-expanded', String(open));
      });
    });

    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && !mobileNav.hidden) closeMenu();
    });

    qsa('.js-menu-close').forEach(btn => {
      btn.addEventListener('click', closeMenu);
    });
  }

  /* Desktop nav dropdowns – keyboard accessible */
  qsa('.site-nav__toggle').forEach(btn => {
    btn.addEventListener('click', () => {
      const open = btn.getAttribute('aria-expanded') === 'true';
      qsa('.site-nav__toggle').forEach(b => b.setAttribute('aria-expanded', 'false'));
      if (!open) btn.setAttribute('aria-expanded', 'true');
    });
    btn.addEventListener('keydown', e => {
      if (e.key === 'Escape') btn.setAttribute('aria-expanded', 'false');
    });
  });
  document.addEventListener('click', e => {
    if (!e.target.closest('.site-nav__item--has-dropdown')) {
      qsa('.site-nav__toggle').forEach(b => b.setAttribute('aria-expanded', 'false'));
    }
  });

  /* Search overlay */
  const searchBtn     = qs('.js-search-toggle');
  const searchOverlay = qs('.js-search-overlay');
  const searchInput   = qs('.js-search-overlay-input');
  const searchClose   = qs('.js-search-overlay-close');

  if (searchBtn && searchOverlay) {
    function openSearch() {
      searchOverlay.hidden = false;
      document.body.style.overflow = 'hidden';
      if (searchInput) setTimeout(() => searchInput.focus(), 50);
    }
    function closeSearch() {
      searchOverlay.hidden = true;
      document.body.style.overflow = '';
    }
    searchBtn.addEventListener('click', openSearch);
    if (searchClose) searchClose.addEventListener('click', closeSearch);
    searchOverlay.addEventListener('click', e => {
      if (e.target === searchOverlay) closeSearch();
    });
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && !searchOverlay.hidden) closeSearch();
    });
  }
})();
